import React from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { PartnerPayoutRecordStage } from '~constants/referral';
import { getSymbolFromCurrency } from '~helpers/currency';

const TransferPreview = ({ transferData = [] }) => {
  const { t } = useTranslation();
  const tableColumns = [
    {
      title: (
        <div className="partner-page__body__list__column-header">
          {t('cms.referral.partner.list.column.partner_code')}
        </div>
      ),
      dataIndex: 'partnerCode',
      key: 'partnerCode',
      className: 'partner-page__body__list__column',
      render: text => <span className="partner-page__body__list__column-body">{text || '-'}</span>,
    },
    {
      title: (
        <div className="partner-page__body__list__column-header">
          {t('cms.referral.payout.list.column.oppos_no')}
        </div>
      ),
      dataIndex: 'bookingNumber',
      key: 'bookingNumber',
      className: 'partner-page__body__list__column',
      render: text => <span className="partner-page__body__list__column-body">{text || '-'}</span>,
    },
    {
      title: (
        <div className="partner-page__body__list__column-header">
          {t('cms.referral.transfer.list.column.passport_first_name')}
        </div>
      ),
      dataIndex: 'passportFirstName',
      key: 'passportFirstName',
      className: 'partner-page__body__list__column',
      render: text => <span className="partner-page__body__list__column-body">{text || '-'}</span>,
    },
    {
      title: (
        <div className="partner-page__body__list__column-header">
          {t('cms.referral.transfer.list.column.passport_last_name')}
        </div>
      ),
      dataIndex: 'passportLastName',
      key: 'passportLastName',
      className: 'partner-page__body__list__column',
      render: text => <span className="partner-page__body__list__column-body">{text || '-'}</span>,
    },
    {
      title: (
        <div className="partner-page__body__list__column-header">
          {t('cms.referral.payout.list.column.trigger_point')}
        </div>
      ),
      dataIndex: 'payoutStage',
      key: 'payoutStage',
      className: 'partner-page__body__list__column',
      render: text => (
        <span className="partner-page__body__list__column-body">
          {t(
            `cms.referral.transfer.editor.select.payout_stage.options.${PartnerPayoutRecordStage[
              text
            ].toLowerCase()}`,
          )}
        </span>
      ),
    },
    {
      title: (
        <div className="partner-page__body__list__column-header">
          {t('cms.referral.transfer.list.column.amount')}
        </div>
      ),
      dataIndex: 'transferAmount',
      key: 'transferAmount',
      className: 'partner-page__body__list__column',
      render: (text, item) => (
        <span className="partner-page__body__list__column-body">
          {text ? `${getSymbolFromCurrency(item.currency)} ${text}` : '-'}
        </span>
      ),
    },
  ];
  return (
    <div>
      <Table
        rowKey={record => record.id}
        columns={tableColumns}
        className="table-list partner-page__body__list"
        dataSource={transferData}
        pagination={false}
      />
    </div>
  );
};

export default TransferPreview;
